import PAGE_TYPES from 'bundles/unified-description-page-common/constants/pageTypes';

import _t from 'i18n!nls/xdp';

const getProjectPageTypeName = (pageType?: typeof PAGE_TYPES[keyof typeof PAGE_TYPES]) => {
  if (pageType === PAGE_TYPES.GUIDED_PROJECT) {
    return _t('Guided Project');
  } else {
    return _t('Project');
  }
};

export default getProjectPageTypeName;
